import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";
import { handleErrorMessage, openSuccessNotification } from "helpers/methods";
import { useState } from "react";
import {
  subscribeContactsById,
  unsubscribeMultiContactsById,
} from "../ViewContactService";
import CustomLoader from "global/components/CustomLoader/CustomLoader";

interface CustomProps {
  isVisible: boolean;
  handleDialogClose: Function;
  contact: any;
  getContactData: any;
  status: number;
}

const ContactStatusChangeModal = (props: CustomProps) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubscribe = async () => {
    try {
      setIsLoading(true);
      const res = await subscribeContactsById(props?.contact.id);
      openSuccessNotification(res.message);
      props.handleDialogClose();
      await props.getContactData();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const handleUnsubscribeContact = async () => {
    try {
      setIsLoading(true);
      const res = await unsubscribeMultiContactsById([props?.contact.id]);
      openSuccessNotification(res.message);
      setIsLoading(false);
      props.handleDialogClose();
      await props.getContactData();
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const getTitle = () => {
    if (props.status !== 0) {
      return "Unsubscribe contact";
    }
    return "Subscribe contact";
  };

  const getDesc = () => {
    if (props.status !== 0) {
      return "Are you sure you want to update the contact's status to Unsubscribe?";
    }
    return "Are you sure you want to set this contact's status to Subscribed? By continuing, you confirm that the contact has given consent to receive emails from us.";
  };

  const getDialogHeader = () => {
    return (
      <Typography variant="h4" color="#7551D0">
        {getTitle()}
      </Typography>
    );
  };

  const getBody = () => {
    return (
      <Stack spacing={3} pt={1}>
        <Typography textAlign="center">{getDesc()}</Typography>
      </Stack>
    );
  };
  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2}>
        <Button
          id="contacts_add__cancel_btn"
          variant="outlined"
          size="small"
          onClick={() => props.handleDialogClose()}
        >
          Cancel
        </Button>
        <Button
          id="contacts_add_save_btn"
          variant="contained"
          size="small"
          onClick={() =>
            props.status !== 0 ? handleUnsubscribeContact() : handleSubscribe()
          }
        >
          {props.status !== 0 ? "Unsubscribe" : "Subscribe"}
        </Button>
      </Stack>
    );
  };

  return (
    <>
      <CustomLoader isLoading={isLoading} />
      <CustomDialog
        handleDialogClose={props.handleDialogClose}
        isDialogOpen={props.isVisible}
        title={getDialogHeader()}
        body={getBody()}
        footer={getFooter()}
        closeButtonVisibility
        closable
        persistOnClickOutside
      />
    </>
  );
};

export default ContactStatusChangeModal;
